const menuAboutFR = {
    "view": {
        "label": {
            "myProfile": "Mon Profil",
            "twoFactorAuthentication": "Authentification à Deux Facteurs",
            "mySubscription": "Mon Abonnement",
            "announcements": "Annonces",
            "mySubUsers": "Mes Sous-Utilisateurs",
            "myLabels": "Mes Labels",
            "escrowWallet": "Portefeuille Séquestre",
            "copyright": "Infractions au Droit d'Auteur",
            "financialStatements": "États Financiers",
            "userStatements": "Relevés Utilisateur",
            "subuserStatements": "Relevés Sous-utilisateur",
            "invoices": "Factures",
            "paymentMethods": "Moyens de Paiement",
            "purchaseHistory": "Historique des Achats",
            "accessKeys": "Clés d'Accès",
            "logout": "Déconnexion"
        }
    }
};

export default menuAboutFR;